/*
 * Google Analytics cart/checkout ecommerce events (GA4 via gtag.js).
 */

const VIEW_CART_SETTLE_MS = 1000;

let viewCartSettleTimer = null;
let cartQtyBatchInProgress = false;
let lastSyncedCartItems = null;
let lastViewCartFingerprint = '';

function sendGaEvent(eventName, params) {
  if (typeof window.gtag !== 'function') {
    return;
  }

  const payload = window.eccubeGaDebug ? { ...params, debug_mode: true } : params;
  window.gtag('event', eventName, payload);
}

function parseJsonScript(id) {
  const el = document.getElementById(id);
  if (!el) {
    return null;
  }

  try {
    return JSON.parse(el.textContent || '');
  } catch (e) {
    return null;
  }
}

function getCartItems() {
  const data = parseJsonScript('ga-cart-data');
  return Array.isArray(data?.items) ? data.items : [];
}

function fingerprintCartItems(items) {
  return items.map((item) => `${item.item_id}:${item.quantity}`).join('|');
}

function syncCartGaData(items, itemsByProductClassId = {}) {
  const gaCartData = document.getElementById('ga-cart-data');
  if (!gaCartData || !Array.isArray(items) || items.length === 0) {
    return;
  }

  gaCartData.textContent = JSON.stringify({ items });

  if (itemsByProductClassId && typeof itemsByProductClassId === 'object') {
    document.querySelectorAll('.delete-product-btn-on-cart[data-product-class-id]').forEach((btn) => {
      const productClassId = btn.getAttribute('data-product-class-id');
      const item = itemsByProductClassId[productClassId];
      if (item) {
        btn.setAttribute('data-ga-item', JSON.stringify(item));
      }
    });
  }
}

function cancelSettledViewCart() {
  if (viewCartSettleTimer) {
    clearTimeout(viewCartSettleTimer);
    viewCartSettleTimer = null;
  }
}

function flushViewCartIfNeeded() {
  if (cartQtyBatchInProgress) {
    return;
  }

  const items = Array.isArray(lastSyncedCartItems) && lastSyncedCartItems.length > 0
    ? lastSyncedCartItems
    : getCartItems();

  if (items.length === 0) {
    return;
  }

  const fingerprint = fingerprintCartItems(items);
  if (fingerprint === lastViewCartFingerprint) {
    return;
  }

  lastViewCartFingerprint = fingerprint;
  sendGaEvent('view_cart', {
    currency: 'JPY',
    items,
  });
}

function scheduleSettledViewCart() {
  cancelSettledViewCart();
  viewCartSettleTimer = setTimeout(() => {
    viewCartSettleTimer = null;
    flushViewCartIfNeeded();
  }, VIEW_CART_SETTLE_MS);
}

function sendBeginCheckout(items) {
  const cartItems = Array.isArray(items) && items.length > 0 ? items : getCartItems();
  if (cartItems.length === 0) {
    return;
  }

  sendGaEvent('begin_checkout', {
    currency: 'JPY',
    items: cartItems,
  });
}

document.addEventListener('eccube:ga:cart-qty-batch-start', () => {
  cartQtyBatchInProgress = true;
  cancelSettledViewCart();
});

document.addEventListener('eccube:ga:cart-qty-batch-end', (event) => {
  const items = event.detail?.items;
  const itemsByProductClassId = event.detail?.itemsByProductClassId || {};

  if (Array.isArray(items) && items.length > 0) {
    lastSyncedCartItems = items;
    syncCartGaData(items, itemsByProductClassId);
  }

  cartQtyBatchInProgress = false;
  scheduleSettledViewCart();
});

function initCartGa() {
  const data = parseJsonScript('ga-cart-data');
  if (!data || !Array.isArray(data.items) || data.items.length === 0) {
    return;
  }

  lastSyncedCartItems = data.items;
  scheduleSettledViewCart();

  document.querySelectorAll('.delete-product-btn-on-cart[data-ga-item]').forEach((btn) => {
    btn.addEventListener('click', () => {
      try {
        const item = JSON.parse(btn.getAttribute('data-ga-item') || 'null');
        if (item) {
          sendGaEvent('remove_from_cart', { items: [item] });
        }
      } catch (e) {
        // ignore invalid payload
      }
    }, true);
  });

  document.querySelectorAll('button.ga-begin-checkout[type="submit"]').forEach((submitBtn) => {
    submitBtn.addEventListener('click', (e) => {
      const form = document.getElementById('cart_store_form') || submitBtn.form;
      if (!form || submitBtn.disabled) {
        return;
      }

      if (form.dataset.gaCheckoutSent === 'true') {
        return;
      }

      e.preventDefault();
      sendBeginCheckout();
      form.dataset.gaCheckoutSent = 'true';
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitBtn);
      } else {
        form.submit();
      }
    }, true);
  });

  document.querySelectorAll('a.ga-begin-checkout').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (link.hasAttribute('disabled') || link.style.pointerEvents === 'none') {
        return;
      }

      e.preventDefault();
      sendBeginCheckout();
      window.location.href = link.href;
    });
  });

  const amazonPayButton = document.getElementById('amazon_pay_button');
  const amazonPayModal = document.getElementById('amazon-pay-modal');
  const continueWithoutLogin = document.getElementById('continue_shipping_without_login');

  if (amazonPayButton && !amazonPayModal) {
    amazonPayButton.addEventListener('click', () => {
      if (amazonPayButton.hasAttribute('disabled') || amazonPayButton.style.pointerEvents === 'none') {
        return;
      }

      sendBeginCheckout();
    }, true);
  }

  if (continueWithoutLogin) {
    continueWithoutLogin.addEventListener('click', () => {
      sendBeginCheckout();
    }, true);
  }
}

function initPurchaseGa() {
  const data = parseJsonScript('ga-purchase-data');
  if (!data) {
    return;
  }

  sendGaEvent('purchase', data);
}

document.addEventListener('DOMContentLoaded', () => {
  initCartGa();
  initPurchaseGa();
});
